module.exports = __webpack_public_path__ + "img/pigsStraw.a5b05c16.jpg";